/* @flow */

import * as React from 'react';

import classnames from 'classnames';

import './button-group.module.css';

type Props = {
    children: React.Node,
    style?: any,
    flexWrap?: {
        justifyContent: 'start' | 'end',
    },
    spacing?: 4 | 8 | 16,
    alignItems?: 'start' | 'end' | 'center',
};

export function ButtonGroup(props: Props) {
    const {spacing = 8, alignItems = 'center'} = props;

    const styleName = classnames('button-group', {
        'button-group--align-start': alignItems === 'start',
        'button-group--align-end': alignItems === 'end',
        'button-group--align-center': alignItems === 'center',
        'button-group--flex-shrink': !props.flexWrap,
        'button-group--flex-wrap': props.flexWrap,
        'button-group--flex-wrap-end': props.flexWrap && props.flexWrap.justifyContent === 'end',
        'button-group--flex-wrap-start':
            props.flexWrap && props.flexWrap.justifyContent === 'start',
    });

    return (
        <div styleName={styleName} style={props.style} className={`gap-${spacing}`}>
            {props.children}
        </div>
    );
}
